import React from 'react';
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { toReduxFormField } from 'services/formUtils';

const DefaultPatientTextField = (props) => {
  // RHF mode: when control + name are provided, wrap in Controller
  if (props.control && props.name) {
    const { control, name, label, placeholder, optional, wrapperClassName, ...rest } = props;
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <DefaultPatientTextField
            field={toReduxFormField(field, fieldState, {
              label,
              placeholder,
              optional,
              wrapperClassName,
            })}
            {...rest}
          />
        )}
      />
    );
  }

  const {
    id,
    value,
    onChange,
    onClick,
    name,
    className,
    label,
    disabled,
    style,
    onKeyDown,
    onBlur,
    type,
    field = {input: {}},
    autoFocus,
    ref,
    error,
    dataLpignore,
    placeholder,
    multiline = false,
    autoComplete,
    forceError,
    inputProps,
    wrapperClassName,
  } = props;

  const errorText = (field.meta && (!field.meta.pristine ? field.meta.error : '')) || (((value || forceError) && error) ? error : "");

  const optional = props.optional || field?.optional;

  let wrapperClassNameFinal = "patient-text-field-wrapper";
  if (wrapperClassName || field?.wrapperClassName) wrapperClassNameFinal += " " + (wrapperClassName || field?.wrapperClassName);

  return (
    <div className={wrapperClassNameFinal}>
      {label || field.label ? (
          <div className="label-wrapper">
            <span className="label">{label || field.label}</span>
            {optional ? <span className="optional"> Optional</span> : null}
          </div>
        )
        : null}
      <TextField
        keepDirtyOnReinitialize={true}
        data-lpignore={dataLpignore}
        autoFocus={autoFocus}
        value={value}
        onClick={onClick}
        onChange={onChange}
        name={name || field.input.name}
        type={type}
        disabled={disabled}
        onKeyDown={onKeyDown}
        style={style || {width: '100%'}}
        {...field.input}
        {...field}
        helperText={errorText}
        error={!!errorText}
        className={`patient-text-field ${className ||
        (field || {}).className ||
        ''}`}
        id={id || (name || field.input.name || '').replace(/\./g, '-') + '-field'}
        ref={ref}
        placeholder={placeholder || field?.placeholder}
        multiline={multiline}
        onBlur={onBlur}
        autoComplete={autoComplete}
        InputProps={inputProps}
      />
    </div>
  );
}

export default DefaultPatientTextField;
